import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import NoProviders from "src/components/streaming/NoProviders";
import StreamingProvider from "src/components/streaming/StreamingProvider";
import StreamingguideLogo from "src/components/streaming/StreamingguideLogo";
import { StreamingProviderContent } from "src/lib/movieinfo/movieinfotypes";
import { uniqBy } from "lodash";
import { useMemo } from "react";
import styles from "./StreamingProviderList.module.css";
import classNames from "classnames";

//#region [Props]
type StreamingProviderListProps = {
    className?: string;
    providerClassName?: string;
    providerListContainerClassName?: string;
    streamingId: number;
    label?: string;
    providers?: StreamingProviderContent[];
    href?: string;
    showLogo?: boolean;
    hideLabel?: boolean;
    sponsor?: React.ReactNode;
};
//#endregion

//#region [Component]
export default function StreamingProviderList({ streamingId, className, providerClassName, providerListContainerClassName, providers, href, showLogo, hideLabel, label = "Her kan du streame filmen/serien", sponsor }: StreamingProviderListProps) {
    const providerList = useMemo(() => providers ? uniqBy(providers, (p) => p.provider!.id) : null, [providers]);
    return <div className={classNames(styles.StreamingProviderList, className)}>
        <div className={styles.Heading}>
            {sponsor}
            {href && <FilmwebLink className={classNames(styles.Label, styles.LabelLink)} to={href}>{label}</FilmwebLink>}
            {!href && <div className={styles.Label}>
                {showLogo && <StreamingguideLogo className={styles.SGLogo} />}
                {!hideLabel && label && <div>{label}</div>}
            </div>}
        </div>
        {(providerList?.length ?? 0) === 0 && <NoProviders streamingId={streamingId} />}
        {(providerList?.length ?? 0) > 0 && <div className={classNames(styles.ProviderList, providerListContainerClassName)}>
            {providerList?.map((provider, pIdx) => <StreamingProvider className={classNames(styles.StreamingProvider, providerClassName)} key={`${streamingId}_${provider.id}`} providerContent={provider} />)}
        </div>}
    </div>;
}
//#endregion
